export default __webpack_public_path__ + "static/events-in-posthog-light-24e32e72686dc094a46f0f984168449d.png";